import * as React from "react";
import { range } from "./range";

interface TimeSignatureProps {
  numBeats: number;
  noteValue: number;
  onChange(timeSignature: [number, number]): void;
}

interface TimeSignatureState {
  shownTimeSigBottom: number;
  shownTimeSigTop: number;
}

// numBeats / noteValue === time sig

export default class TimeSignature extends React.Component<TimeSignatureProps> {
  state: TimeSignatureState = {
    shownTimeSigTop: this.props.numBeats,
    shownTimeSigBottom: this.props.noteValue
  };

  render() {
    return (
      <div>
        <select
          value={this.state.shownTimeSigTop}
          name="timeSigTop"
          onChange={this._changeTimeTop}
        >
          {range(2, 15).map(v => (
            <option key={v} value={v}>
              {v}
            </option>
          ))}
        </select>
        /
        <select
          value={this.state.shownTimeSigBottom}
          name="timeSigBot"
          onChange={this._changeTimeBottom}
        >
          {[4, 8, 16].map(v => (
            <option key={v} value={v}>
              {v}
            </option>
          ))}
        </select>
        <button
          type="button"
          disabled={
            this.state.shownTimeSigTop === this.props.numBeats &&
            this.state.shownTimeSigBottom === this.props.noteValue
          }
          onClick={this._changeTime}
        >
          change time
        </button>
      </div>
    );
  }
  
  private _changeTimeTop = (ev: React.ChangeEvent<HTMLSelectElement>) => {
    this.setState({ shownTimeSigTop: parseInt(ev.target.value, 10) });
  };

  private _changeTimeBottom = (ev: React.ChangeEvent<HTMLSelectElement>) => {
    this.setState({ shownTimeSigBottom: parseInt(ev.target.value, 10) });
  };

  private _changeTime = () => {
    this.props.onChange([this.state.shownTimeSigTop, this.state.shownTimeSigBottom])
  }
}



// WEBPACK FOOTER //
// ./src/timeSignature.tsx